import { createFileRoute } from "@tanstack/react-router";
import { DownloadPage } from "./-DownloadPage";

export const Route = createFileRoute("/download")({
  component: DownloadPage,
});
